export default __webpack_public_path__ + "static/media/ic_facebook_fill.d922f97b.svg";